Vue.component('content-functionalities', {
    delimiters: ['[[', ']]'],
    template: `
        <div id="contentFunctionalities">

            <div class="" style='text-align:center' data-custom-animations="true" data-ca-options='{"triggerHandler":"inview","animationTarget":"all-childs","duration":1200,"delay":160,"initValues":{"translateY":50,"opacity":0},"animations":{"translateY":0,"opacity":1}}'>
                <header class="fancy-title mb-50">
                    <h6 class="text-uppercase">CHECK OUT OUR TECHNOLOGY</h6>
                    <h2 class="lh-1 mb-0" data-fittext="true" data-fittext-options='{"compressor":0.65, "maxFontSize":"72", "minFontSize":"48"}'>Main <strong class="sq-font">SpartaQuant</strong> functionalities</h2>
                </header>
            </div><!-- /.col-lg-4 col-md-12 -->

            <section class="vc_row pt-100 pb-100 contentFunctionalitiesDesktop">
				<div class="container">
					<div class="row">

						<div class="lqd-column col-md-6 col-md-offset-3">

							<div class="one-ib-circ" data-spread-incircle="true" data-hover3d="true">

								<div class="one-ib-circ-wrap" data-stacking-factor="0.95">
							
									<div class="one-ib-circ-inner">
							
										<div class="one-ib-circ-item">
							
											<div class="one-ib-circ-icn">
												<span>
                                                    <i class="fa fa-pie-chart"></i>
												</span>
											</div><!-- /.one-ib-circ-icn -->
											
											<div class="one-ib-circ-cnt">
												<h3>Dashboards</h3>
												<hr>
												<p>Configure your own dashboards in a few clicks</p>
											</div><!-- /.one-ib-circ-cnt -->
							
										</div><!-- /.one-ib-circ-item -->
							
										<div class="one-ib-circ-item">
							
											<div class="one-ib-circ-icn">
												<span>
													<i class="fa fa-database"></i>
												</span>
											</div><!-- /.one-ib-circ-icn -->
											
											<div class="one-ib-circ-cnt">
												<h3>Database</h3>
												<hr>
												<p>Search your data, plug into other databases or xls files</p>
											</div><!-- /.one-ib-circ-cnt -->
							
										</div><!-- /.one-ib-circ-item -->
							
										<div class="one-ib-circ-item">
							
											<div class="one-ib-circ-icn">
												<span>
													<i class="fa fa-history"></i>
												</span>
											</div><!-- /.one-ib-circ-icn -->
											
											<div class="one-ib-circ-cnt">
												<h3>Scheduler</h3>
												<hr>
												<p>Manage your scheduled tasks</p>
											</div><!-- /.one-ib-circ-cnt -->
							
										</div><!-- /.one-ib-circ-item -->
							
										<div class="one-ib-circ-item">
							
											<div class="one-ib-circ-icn">
												<span>
													<i class="fa fa-bullhorn"></i>
												</span>
											</div><!-- /.one-ib-circ-icn -->
											
											<div class="one-ib-circ-cnt">
												<h3>Alerts</h3>
												<hr>
												<p>Configure alerts and get notified on specific events</p>
											</div><!-- /.one-ib-circ-cnt -->
							
										</div><!-- /.one-ib-circ-item -->

                                        <div class="one-ib-circ-item">
							
											<div class="one-ib-circ-icn">
												<span>
                                                    <i aria-hidden="true" style="font-size:25px;">f<sub>(x)</sub></i>
												</span>
											</div><!-- /.one-ib-circ-icn -->
											
											<div class="one-ib-circ-cnt">
												<h3>Functions</h3>
												<hr>
												<p>Choose from a variety of pre-built functions and develop your own building blocks</p>
											</div><!-- /.one-ib-circ-cnt -->
							
										</div><!-- /.one-ib-circ-item -->

                                        <div class="one-ib-circ-item">
							
											<div class="one-ib-circ-icn">
												<span>
                                                    <i class="fa fa-code"></i>
												</span>
											</div><!-- /.one-ib-circ-icn -->
											
											<div class="one-ib-circ-cnt">
												<h3>Code editor</h3>
												<hr>
												<p>Create your functions with the code editor</p>
											</div><!-- /.one-ib-circ-cnt -->
							
										</div><!-- /.one-ib-circ-item -->

                                        <div class="one-ib-circ-item">
							
											<div class="one-ib-circ-icn">
												<span>
													<i class="fa fa-calculator"></i>
												</span>
											</div><!-- /.one-ib-circ-icn -->
											
											<div class="one-ib-circ-cnt">
												<h3>Quant Calculator</h3>
												<hr>
												<p>Create indicators and models using the Quant Calculator without coding</p>
											</div><!-- /.one-ib-circ-cnt -->
							
										</div><!-- /.one-ib-circ-item -->
							
									</div><!-- /.one-ib-circ-inner -->
									
								</div><!-- /.one-ib-circ-wrap -->
							
							</div><!-- /.one-ib-circ -->

						</div><!-- /.lqd-column col-md-6 col-md-offset-3 -->

					</div><!-- /.row -->
				</div><!-- /.container -->
			</section>

			<section class="vc_row pt-90 pb-50 contentFunctionalitiesMobile">
				<div class="container">
					<div class="row">

						<div class="lqd-column col-md-6">

							<div id="iconbox-linked-1" class="iconbox iconbox-side iconbox-circle iconbox-md iconbox-heading-sm iconbox-icon-linked" data-animate-icon="true" data-plugin-options='{"resetOnHover":true,"color":"rgb(51, 51, 51)","hoverColor":"rgb(255, 255, 255)"}' data-shape-border="1">
								<div class="iconbox-icon-wrap">
									<span class="iconbox-icon-container">
										<span class="functionalitiesIcon">
											<i class="fa fa-calculator"></i>
										</span>
									</span>
								</div><!-- /.iconbox-icon-wrap -->
								<div class="contents">
									<h3 class="font-weight-semibold">Quant Calculator</h3>
									<p>Create indicators and models using the Quant Calculator without coding</p>
								</div><!-- /.contents -->
							</div><!-- /.iconbox -->

							<div id="iconbox-linked-2" class="iconbox iconbox-side iconbox-circle iconbox-md iconbox-heading-sm iconbox-icon-linked" data-animate-icon="true" data-plugin-options='{"resetOnHover":true,"color":"rgb(51, 51, 51)","hoverColor":"rgb(255, 255, 255)"}' data-shape-border="1">
								<div class="iconbox-icon-wrap">
									<span class="iconbox-icon-container">
										<span class="functionalitiesIcon">
											<i class="fa fa-pie-chart"></i>
										</span>
									</span>
								</div><!-- /.iconbox-icon-wrap -->
								<div class="contents">
									<h3 class="font-weight-semibold">Dashboards</h3>
									<p>Configure your own dashboards in a few clicks</p>
								</div><!-- /.contents -->
							</div><!-- /.iconbox -->

							<div id="iconbox-linked-3" class="iconbox iconbox-side iconbox-circle iconbox-md iconbox-heading-sm iconbox-icon-linked" data-animate-icon="true" data-plugin-options='{"resetOnHover":true,"color":"rgb(51, 51, 51)","hoverColor":"rgb(255, 255, 255)"}' data-shape-border="1">
								<div class="iconbox-icon-wrap">
									<span class="iconbox-icon-container">
										<span class="functionalitiesIcon">
											<i class="fa fa-database"></i>
										</span>
									</span>
								</div><!-- /.iconbox-icon-wrap -->
								<div class="contents">
									<h3 class="font-weight-semibold">Database</h3>
									<p>Search your data, plug into other databases or xls files</p>
								</div><!-- /.contents -->
							</div><!-- /.iconbox -->

							<div id="iconbox-linked-4" class="iconbox iconbox-side iconbox-circle iconbox-md iconbox-heading-sm iconbox-icon-linked" data-animate-icon="true" data-plugin-options='{"resetOnHover":true,"color":"rgb(51, 51, 51)","hoverColor":"rgb(255, 255, 255)"}' data-shape-border="1">
								<div class="iconbox-icon-wrap">
									<span class="iconbox-icon-container">
										<span class="functionalitiesIcon">
											<i class="fa fa-history"></i>
										</span>
									</span>
								</div><!-- /.iconbox-icon-wrap -->
								<div class="contents">
									<h3 class="font-weight-semibold">Scheduler</h3>
									<p>Manage your scheduled tasks</p>
								</div><!-- /.contents -->
							</div><!-- /.iconbox -->

						</div><!-- /.col-md-6 -->

						<div class="lqd-column col-md-6">

							<div id="iconbox-linked-5" class="iconbox iconbox-side iconbox-circle iconbox-md iconbox-heading-sm iconbox-icon-linked" data-animate-icon="true" data-plugin-options='{"resetOnHover":true,"color":"rgb(51, 51, 51)","hoverColor":"rgb(255, 255, 255)"}' data-shape-border="1">
								<div class="iconbox-icon-wrap">
									<span class="iconbox-icon-container">
										<span class="functionalitiesIcon">
											<i class="fa fa-bullhorn"></i>
										</span>
									</span>
								</div><!-- /.iconbox-icon-wrap -->
								<div class="contents">
									<h3 class="font-weight-semibold">Alerts</h3>
									<p>Configure alerts and get notified on specific events</p>
								</div><!-- /.contents -->
							</div><!-- /.iconbox -->

							<div id="iconbox-linked-6" class="iconbox iconbox-side iconbox-circle iconbox-md iconbox-heading-sm iconbox-icon-linked" data-animate-icon="true" data-plugin-options='{"resetOnHover":true,"color":"rgb(51, 51, 51)","hoverColor":"rgb(255, 255, 255)"}' data-shape-border="1">
								<div class="iconbox-icon-wrap">
									<span class="iconbox-icon-container">
										<i aria-hidden="true" class="functionalitiesIcon">f<sub>(x)</sub></i>
									</span>
								</div><!-- /.iconbox-icon-wrap -->
								<div class="contents">
									<h3 class="font-weight-semibold">Functions</h3>
									<p>Choose from a variety of pre-built functions and develop your own building blocks</p>
								</div><!-- /.contents -->
							</div><!-- /.iconbox -->

							<div id="iconbox-linked-7" class="iconbox iconbox-side iconbox-circle iconbox-md iconbox-heading-sm iconbox-icon-linked" data-animate-icon="true" data-plugin-options='{"resetOnHover":true,"color":"rgb(51, 51, 51)","hoverColor":"rgb(255, 255, 255)"}' data-shape-border="1">
								<div class="iconbox-icon-wrap">
									<span class="iconbox-icon-container">
										<span class="functionalitiesIcon">
											<i class="fa fa-code"></i>
										</span>
									</span>
								</div><!-- /.iconbox-icon-wrap -->
								<div class="contents">
									<h3 class="font-weight-semibold">Code editor</h3>
									<p>Create your functions with the code editor</p>
								</div><!-- /.contents -->
							</div><!-- /.iconbox -->

						</div><!-- /.col-md-6 -->

					</div><!-- /.row -->
				</div><!-- /.container -->
			</section>

        </div>
    `,
    props: {
        idcomponent: {
            type: String,
            default: 'menu'
        },
    },
    data: function () {
        return {

        }
    },
    mounted(){

    },
    methods: {
        
    },
});